<template>
  <v-card>
    <v-card-title>{{ title }}</v-card-title>
    <v-card-text>
      <v-form @submit.prevent v-model="valid">
        <v-text-field
          :label="$t('identifier')"
          hint="Por ejemplo: 1, Frente"
          v-model="caja.name"
          :rules="$rule('max128')"
          persistent-hint
          outlined
          dense
        ></v-text-field>
        <v-text-field
          label="Clave de caja"
          hint="Clave de 4 digitos para administrar la caja"
          v-model="caja.adminKey"
          :rules="$rule('number|min4|max4')"
          type="password"
          persistent-hint
          outlined
          dense
          maxlength="4"
        ></v-text-field>
      </v-form @submit.prevent>
    </v-card-text>
    <v-card-actions class="justify-end">
      <v-btn text @click="cancel" :disabled="loading">{{ $t('cancel') }}</v-btn>
      <v-btn
        color="primary"
        :disabled="!valid"
        @click="save"
        :loading="loading"
        >{{ $t('save') }}</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script lang="ts">
  import { Component, Vue, Prop } from 'vue-property-decorator';
  import { ICaja } from '../../interfaces/ICaja';
  import CajasService from '../../api/services/cajas.service';
  import { vueData } from '../../VueData';
  import { AlertType } from '../../interfaces/IAlert';
import { useRestaurantStore } from '@/stores/restaurant.store';

  @Component
  export default class NewCajaModal extends Vue {
    @Prop() caja: ICaja;
    loading = false;
    title = '';
    valid = false;
    restaurantStore = useRestaurantStore();

    mounted() {
      this.title = !this.caja.id
        ? this.$tc('caja.new')
        : this.$t('caja.editing', { name: this.caja.name }).toString();
    }

    async save() {
      this.loading = true;
      try {
        let caja = !this.caja.id
          ? await CajasService.create({...this.caja, adminKey: parseInt(this.caja.adminKey+'')})
          : await CajasService.update({
            restaurantId: this.caja.restaurantId,
            branchId: this.caja.branchId,
            id: this.caja.id,
          }, {
            name: this.caja.name || undefined,
            adminKey: this.caja.adminKey ? parseInt(this.caja.adminKey+'') : undefined,
          });
        vueData.addAlert(this.$tc('caja.saved'), AlertType.Success);
        if (!this.caja.id)
          this.$gtag.event('create', { event_category: 'caja' });
        else {
          const storedCaja = this.restaurantStore.cajas?.find(
            (c) => c.id === this.caja.id
          );

          if (storedCaja) {
            storedCaja.status = caja.status;
            storedCaja.name = caja.name;
          }
        }
        
        this.$parent.$emit('saved', caja);
        this.$emit('close');
      } catch (e) {
        console.error(e);
        vueData.serverError(e, this.$tc('caja.errorSaving'));
      } finally {
        this.loading = false;
      }
    }

    cancel() {
      this.$emit('close');
    }
  }
</script>
